<div class="reservations-container">
    <div class="reservations-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/shield_check_red.png" alt="shield_check_red Icon" class="file-icon">
            <span class="header-title">
            <span class="title-text">Réservations ( <span class="title-count">{{ totalCount }}</span> )</span>

            </span>
        </div>

        <div class="header-right">
            <!--<button *ngIf="reservations.length > 0" class="add-article-btn" (click)="addNewArticle()">
                <img src="assets/images/icons/file_check_gray.png" alt="file_check icon" class="add-icon">
                <span>Évènements passer ( <strong>42</strong> )</span>
            </button>-->
        </div>
    </div>

    <div class="search-filter-row">
        <div class="search-container">
            <div class="search-input-group">
                <img src="assets/images/icons/input_search.png" alt="Search" class="search-icon">
                <input type="text" class="search-input" placeholder="Rechercher (nom d'evenement, nom du client)..." [(ngModel)]="searchTerm" (input)="onSearch()">
            </div>
        </div>
        <div class="filter-group">
            <select class="filter-select custom-select" [(ngModel)]="selectedStatus" (change)="onFilterChange()">
                <option value="all">Tous(status)</option>
                
            </select>
        </div>

        <div class="filter-group">
            <select class="filter-select custom-select" [(ngModel)]="selectedSort" (change)="onSortChange()">
                <option value="" disabled>Trier par</option>
                <option value="createdAt,desc">Date (plus récent)</option>
                <option value="createdAt,asc">Date (plus ancien)</option>
                <option value="eventName,asc">Titre (A-Z)</option>
                <option value="eventName,desc">Titre (Z-A)</option>
            </select>
        </div>

        <button class="filter-btn custom-select" (click)="toggleFilterPopup()">
            <img src="assets/images/icons/filter.png" alt="Filter" class="filter-icon">
            <span>Filtrer</span>
        </button>
    </div>

    <div *ngIf="isLoading" class="loading-state">
        <div class="loading-spinner"></div>
        <p>Chargement des réservations...</p>
    </div>

    <div *ngIf="!isLoading && reservations.length === 0" class="empty-state">
        <p>Aucun réservations trouvé</p>
    </div>

    <div *ngIf="!isLoading && reservations.length > 0" class="reservations-grid">
        <app-admin-reservation-card class="reservation-card" *ngFor="let reservation of reservations" [reservation]="reservation" (reservationUpdated)="onReservationUpdated()" (reservationDeleted)="onReservationDeleted()">
        </app-admin-reservation-card>
        <app-pagination *ngIf="totalPages>1" [currentPage]="currentPage" [totalPages]="totalPages" (pageChange)="onPageChange($event)"></app-pagination>
    </div>

</div>

<div class="filter-overlay" *ngIf="showFilterPopup" (click)="closeFilterPopup($event)">
    <div class="filter-popup">

        <div class="filter-header">
            <h3 class="filter-title">Filtrer</h3>
            <button class="close-button" (click)="toggleFilterPopup()">×</button>
        </div>

    </div>
</div>